import CryptoJS from 'crypto-js'

// AppKey 和 AppSecret（与后端保持一致）
const APP_KEY = 'ch2f1cdfad5a6t3sfc25'
const APP_SECRET = 'e6c92b84f37d1a5e0b6c4d9f2a8b7e1c3d5a6f0b2c1d8e9a4f5b6c7d8e9f0a1b'

/**
 * 生成浏览器特征 device-id
 * 基于浏览器指纹生成唯一标识
 */
function generateDeviceId() {
  const navigator = window.navigator
  const screen = window.screen

  // 收集浏览器特征
  const features = [
    navigator.userAgent,
    navigator.language,
    screen.colorDepth,
    screen.width + 'x' + screen.height,
    new Date().getTimezoneOffset(),
    !!window.sessionStorage,
    !!window.localStorage,
    navigator.hardwareConcurrency || '',
    navigator.platform || ''
  ]

  // 生成特征字符串的 hash
  const featureString = features.join('|')
  return CryptoJS.SHA256(featureString).toString(CryptoJS.enc.Hex).substring(0, 32)
}

/**
 * 获取或生成 device-id
 */
function getDeviceId() {
  const storageKey = 'chivox_device_id'
  let deviceId = localStorage.getItem(storageKey)

  if (!deviceId) {
    deviceId = generateDeviceId()
    localStorage.setItem(storageKey, deviceId)
  }

  return deviceId
}

/**
 * 生成 HMAC-SHA256 签名
 * @param {Object} params - 需要签名的参数
 * @returns {string} 签名结果
 */
function generateSignature(params) {
  // 按 key 进行 A-Z 排序
  const sortedKeys = Object.keys(params).sort()

  // 拼接成规范字符串（value 用 & 连接）
  const signString = sortedKeys.map(key => params[key]).join('&')

  // HMAC-SHA256 加密生成签名
  return CryptoJS.HmacSHA256(signString, APP_SECRET).toString(CryptoJS.enc.Hex)
}

/**
 * 请求签名拦截器
 * 为每个请求添加签名所需的 header 参数
 */
export default function signature(request) {
  const timestamp = Math.floor(Date.now() / 1000).toString()
  const deviceId = getDeviceId()

  // 构建签名参数
  const signParams = {
    appkey: APP_KEY,
    timestamp: timestamp,
    deviceId: deviceId
  }

  // 生成签名
  const signature = generateSignature(signParams)

  // 设置请求头
  request.headers['x-chivox-timestamp'] = timestamp
  request.headers['x-chivox-device-id'] = deviceId
  request.headers['x-chivox-signature'] = signature

  return request
}



// WEBPACK FOOTER //
// ./src/axios/signature.js